import React from 'react';
import { trucks, deliveries } from '../data/mockData';

const StatisticsPanel: React.FC = () => {
  // Calcul des statistiques à partir des données mockées
  const activeDeliveries = deliveries.filter(d => d.status === 'en_cours').length;
  const completedDeliveries = deliveries.filter(d => d.status === 'terminée').length;
  const plannedDeliveries = deliveries.filter(d => d.status === 'planifiée').length;
  const activeTrucks = trucks.filter(t => t.status !== 'arrêté').length;
  
  // Calcul du pourcentage de livraisons à l'heure (simulé)
  const onTimePercentage = 85;
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {/* Livraisons actives */}
      <div className="bg-white rounded-lg shadow-md p-5">
        <div className="flex items-center">
          <div className="flex-shrink-0 bg-blue-100 rounded-full p-3">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          </div>
          <div className="ml-5">
            <p className="text-gray-500 text-sm font-medium">Livraisons actives</p>
            <div className="flex items-center">
              <h3 className="font-bold text-2xl text-gray-900">{activeDeliveries}</h3>
              <span className="ml-2 text-sm font-medium text-green-600 bg-green-100 px-2 py-0.5 rounded-full">
                En cours
              </span>
            </div>
          </div>
        </div>
        <div className="mt-4">
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div className="bg-blue-600 h-2 rounded-full" style={{ width: `${(activeDeliveries / deliveries.length) * 100}%` }}></div>
          </div>
          <p className="mt-1 text-xs text-gray-500">
            {Math.round((activeDeliveries / deliveries.length) * 100)}% des livraisons du jour
          </p>
        </div>
      </div>
      
      {/* Camions en service */}
      <div className="bg-white rounded-lg shadow-md p-5">
        <div className="flex items-center">
          <div className="flex-shrink-0 bg-green-100 rounded-full p-3">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0" />
            </svg>
          </div>
          <div className="ml-5">
            <p className="text-gray-500 text-sm font-medium">Camions en service</p>
            <div className="flex items-center">
              <h3 className="font-bold text-2xl text-gray-900">{activeTrucks}</h3>
              <span className="ml-2 text-sm font-medium text-green-600">
                / {trucks.length} disponibles
              </span>
            </div>
          </div>
        </div>
        <div className="mt-4">
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div className="bg-green-600 h-2 rounded-full" style={{ width: `${(activeTrucks / trucks.length) * 100}%` }}></div>
          </div>
          <p className="mt-1 text-xs text-gray-500">
            {Math.round((activeTrucks / trucks.length) * 100)}% de la flotte active
          </p>
        </div>
      </div>
      
      {/* Livraisons planifiées */}
      <div className="bg-white rounded-lg shadow-md p-5">
        <div className="flex items-center">
          <div className="flex-shrink-0 bg-purple-100 rounded-full p-3">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          </div>
          <div className="ml-5">
            <p className="text-gray-500 text-sm font-medium">Livraisons planifiées</p>
            <div className="flex items-center">
              <h3 className="font-bold text-2xl text-gray-900">{plannedDeliveries}</h3>
              <span className="ml-2 text-sm font-medium text-purple-600 bg-purple-100 px-2 py-0.5 rounded-full">
                À venir
              </span>
            </div>
          </div>
        </div>
        <div className="mt-4">
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div className="bg-purple-600 h-2 rounded-full" style={{ width: `${(plannedDeliveries / deliveries.length) * 100}%` }}></div>
          </div>
          <p className="mt-1 text-xs text-gray-500">
            {Math.round((plannedDeliveries / deliveries.length) * 100)}% des livraisons du jour
          </p>
        </div>
      </div>
      
      {/* Livraisons à l'heure */}
      <div className="bg-white rounded-lg shadow-md p-5">
        <div className="flex items-center">
          <div className="flex-shrink-0 bg-yellow-100 rounded-full p-3">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div className="ml-5">
            <p className="text-gray-500 text-sm font-medium">Livraisons à l'heure</p>
            <div className="flex items-center">
              <h3 className="font-bold text-2xl text-gray-900">{onTimePercentage}%</h3>
              <span className="ml-2 text-sm font-medium text-yellow-600">
                Ponctualité
              </span>
            </div>
          </div>
        </div>
        <div className="mt-4">
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div className="bg-yellow-600 h-2 rounded-full" style={{ width: `${onTimePercentage}%` }}></div>
          </div>
          <p className="mt-1 text-xs text-gray-500">
            Objectif: 90% de livraisons à l'heure
          </p>
        </div>
      </div>
    </div>
  );
};

export default StatisticsPanel;
